import { useEffect, useState } from 'react';
import Layout from './Layout';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../client/client';
import { useLogin } from '../context/LoginContext';

const BackupsForm = () => {
  const [loading, setLoading]             = useState(true);
  const [error, setError]                 = useState(null);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const { getSessionAuth }                = useLogin();
  const navigate                          = useNavigate();

  const frecuencyOptions = ['Cada mes', 'Cada 2 meses', 'Cada 6 meses', 'Cada año'];

  useEffect(() => {
    const sessionAuth = async () => {
      const session = await getSessionAuth();
      if (session) {
        setLoading(false);
      } else {
        navigate("/", { replace: true });
      }
    };
    sessionAuth();
  }, []);

  const [formData, setFormData] = useState({
    date_backup:          '',
    date_next_backup:     '',
    frecuency_maintenance: '',
  });

  const [equiposList, setEquiposList]     = useState([]);
  const [selectedEquipo, setSelectedEquipo] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: equiposData, error: equiposError } = await supabase
          .from('equipos')
          .select('id, title, attendant')
          .eq('area', 'ARBITRAJE');

        if (equiposError) {
          console.error('Error fetching equipos:', equiposError);
        } else {
          setEquiposList(equiposData);
        }
      } catch (e) {
        console.error('Error fetching equipos:', e.message);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEquipoChange = (e) => {
    const found = equiposList.find((eq) => eq.id === e.target.value) || null;
    setSelectedEquipo(found);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const { error: dbError } = await supabase.from('backups').upsert([
        {
          id_equipo:             selectedEquipo?.id || null,
          equipo_title:          selectedEquipo?.title || '',
          equipo_attendant:      selectedEquipo?.attendant || '',
          date_backup:           formData.date_backup,
          date_next_backup:      formData.date_next_backup,
          frecuency_maintenance: formData.frecuency_maintenance,
        },
      ]);

      if (dbError) {
        setError('Error al guardar el backup.');
      } else {
        setShowSuccessDialog(true);
      }
    } catch (e) {
      setError('Error inesperado al guardar.');
    }
  };

  const handleAccept = () => {
    setShowSuccessDialog(false);
    navigate("/equipos");
  };

  return (
    <Layout>
      <form onSubmit={handleSubmit}>
        <h1 className='text-3xl font-bold text-[#4691A6] flex justify-center pb-10'>BACKUPS</h1>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
            {error}
          </div>
        )}

        <div className="form-row">
          <div className="field">
            <label className='text-xs font-semibold'>
              Equipo:
              <select name="equipo" value={selectedEquipo?.id || ''} onChange={handleEquipoChange}>
                <option value="" disabled>Selecciona un equipo</option>
                {equiposList.map((equipo) => (
                  <option key={equipo.id} value={equipo.id}>
                    {equipo.title} — {equipo.attendant}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </div>

        <div className="form-row">
          <div className="field">
            <label className='text-xs font-semibold'>
              Fecha del backup:
              <input
                type="date"
                name="date_backup"
                value={formData.date_backup}
                onChange={handleChange}
              />
            </label>
          </div>
          <div className="field">
            <label className='text-xs font-semibold'>
              Fecha del próximo backup:
              <input
                type="date"
                name="date_next_backup"
                value={formData.date_next_backup}
                onChange={handleChange}
              />
            </label>
          </div>
          <div className="field">
            <label className='text-xs font-semibold'>
              Frecuencia:
              <div className="styled-select">
                <select
                  name="frecuency_maintenance"
                  value={formData.frecuency_maintenance}
                  onChange={handleChange}
                  className="styled-select"
                >
                  <option value="">Selecciona una opción</option>
                  {frecuencyOptions.map((option) => (
                    <option key={option} value={option}>{option}</option>
                  ))}
                </select>
              </div>
            </label>
          </div>
        </div>

        <div className="form-row">
          <button
            className="bg-[#356674] hover:bg-[#4691A6] transition-colors duration-300 text-base cursor-pointer mt-7 text-white font-semibold py-2 px-4 rounded-md w-full"
            type="submit"
          >
            Guardar
          </button>
        </div>

        {showSuccessDialog && (
          <div className="success-dialog">
            <p>Se ha guardado exitosamente</p>
            <button
              onClick={handleAccept}
              className="bg-[#356674] hover:bg-[#4691A6] transition-colors duration-300 text-base cursor-pointer mt-7 text-white font-semibold py-2 px-4 rounded-md w-full"
            >
              Aceptar
            </button>
          </div>
        )}
      </form>
    </Layout>
  );
};

export default BackupsForm;
